<template>
    <glass-dialog
        v-model="dialog"
        :max-width="520"
        :title="dialogTitle"
        @close="$emit('close')"
    >
        <v-form @submit.prevent="save">
            <v-row>
                <v-col
                    v-if="!payload._id"
                    cols="12"
                >
                    <v-select
                        v-model="payload.role"
                        label="Tipo de usuário"
                        outlined
                        hide-details="auto"
                        item-text="text"
                        item-value="value"
                        :items="$user.roles"
                    />
                </v-col>

                <v-col cols="12">
                    <v-text-field
                        v-model="payload.name"
                        autocomplete="nope"
                        label="Nome"
                        outlined
                        hide-details="auto"
                    />
                </v-col>

                <v-col cols="12">
                    <v-text-field
                        v-model="payload.email"
                        autocomplete="nope"
                        label="E-mail"
                        outlined
                        hide-details="auto"
                    />
                </v-col>

                <v-col cols="12">
                    <v-text-field
                        v-model="payload.password"
                        autocomplete="nope"
                        label="Senha"
                        outlined
                        hide-details="auto"
                        :messages="!payload.admin ? 'O cliente receberá um email com essa senha' : ''"
                    />
                </v-col>

                <v-col cols="12">
                    <v-switch
                        v-model="payload.no_email"
                        inset
                        color="primary"
                        label="Não enviar e-mail de boas vindas"
                        hide-details="auto"
                        class="mt-0"
                    />
                </v-col>
            </v-row>
        </v-form>

        <template #actions>
            <v-btn
                text
                @click="$emit('close')"
            >
                Cancelar
            </v-btn>
            <v-btn
                color="primary"
                depressed
                :loading="saving"
                @click="save"
            >
                Salvar
            </v-btn>
        </template>
    </glass-dialog>
</template>

<script>
export default {
    name: 'UserDialog',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        user: {
            type: Object,
            default: () => ({})
        },
    },
    data() {
        return {
            payload: {},
            vindiSubscriptions: [],
            saving: false
        }
    },
    computed: {
        dialog: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        },
        users() {
            return this.$store.state.users.data
        },
        dialogTitle() {
            const verb = this.payload._id ? 'Editar' : 'Novo'
            const role = this.payload.admin ? 'administrador' : 'cliente'
            return `${verb} ${role}`
        },
    },
    watch: {
        dialog(isOpen) {
            if (isOpen) {
                this.syncPayload()
            }
        },
        user: {
            handler() {
                if (this.dialog) {
                    this.syncPayload()
                }
            },
            deep: true
        }
    },
    methods: {
        syncPayload() {
            const data = JSON.parse(JSON.stringify(this.user || {}))

            data.accesses = data.accesses || []
            data.accesses = data.accesses.map(access => access.user_id)

            this.payload = data
        },
        async loadVindiSubscriptions() {
            const response = await this.$api.getVindiSubscriptions()

            if (response.error) {
                return
            }

            this.vindiSubscriptions = response.message
        },
        async save() {
            this.saving = true

            const data = JSON.parse(JSON.stringify(this.payload))
            const response = await this.$api.createUser(data)

            if (response.error) {
                this.saving = false
                return
            }

            await this.$router.push(`/users/${response.user?._id}`)

            setTimeout(() => {
                this.saving = false
                this.dialog = false
                this.$emit('saved')
                this.$toast('success', 'Operação bem sucedida.')
            }, 1000)
        }
    },
    created() {
        this.loadVindiSubscriptions()
    },
}
</script>
